// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type Automation,
    AutomationFromJSON,
    AutomationToJSON,
} from '../models/Automation';
import {
    type AutomationInput,
    AutomationInputFromJSON,
    AutomationInputToJSON,
} from '../models/AutomationInput';
import {
    type AutomationList,
    AutomationListFromJSON,
    AutomationListToJSON,
} from '../models/AutomationList';

export interface CreateAutomationRequest {
    /**
     * 
     */
    automationInput: AutomationInput;
}

export interface DeleteAutomationRequest {
    /**
     * Automation ID
     */
    automationId: string;
}

export interface GetAutomationsRequest {
    /**
     * Filter by room ID
     */
    room?: string;
    /**
     * Filter by device ID (can be multiple)
     */
    device?: Array<string>;
}

export interface UpdateAutomationRequest {
    /**
     * Automation ID
     */
    automationId: string;
    /**
     * 
     */
    automationInput: AutomationInput;
}

/**
 * 
 */
export class AutomationApi extends runtime.BaseAPI {

    /**
     * Creates request options for createAutomation without sending the request
     */
    async createAutomationRequestOpts(requestParameters: CreateAutomationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['automationInput'] == null) {
            throw new runtime.RequiredError(
                'automationInput',
                'Required parameter "automationInput" was null or undefined when calling createAutomation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/automations/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AutomationInputToJSON(requestParameters['automationInput']),
        };
    }

    /**
     * Create a new automation
     * Create a new automation
     */
    async createAutomationRaw(requestParameters: CreateAutomationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Automation>> {
        const requestOptions = await this.createAutomationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AutomationFromJSON(jsonValue));
    }

    /**
     * Create a new automation
     * Create a new automation
     */
    async createAutomation(requestParameters: CreateAutomationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Automation> {
        const response = await this.createAutomationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteAutomation without sending the request
     */
    async deleteAutomationRequestOpts(requestParameters: DeleteAutomationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['automationId'] == null) {
            throw new runtime.RequiredError(
                'automationId',
                'Required parameter "automationId" was null or undefined when calling deleteAutomation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/automations/{automationId}`;
        urlPath = urlPath.replace('{automationId}', encodeURIComponent(String(requestParameters['automationId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete an existing automation
     * Delete an automation
     */
    async deleteAutomationRaw(requestParameters: DeleteAutomationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteAutomationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete an existing automation
     * Delete an automation
     */
    async deleteAutomation(requestParameters: DeleteAutomationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAutomationRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getAutomations without sending the request
     */
    async getAutomationsRequestOpts(requestParameters: GetAutomationsRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['room'] != null) {
            queryParameters['room'] = requestParameters['room'];
        }

        if (requestParameters['device'] != null) {
            queryParameters['device'] = requestParameters['device'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/automations/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Retrieve automations with optional filtering by room and device
     * Get automations
     */
    async getAutomationsRaw(requestParameters: GetAutomationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AutomationList>> {
        const requestOptions = await this.getAutomationsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AutomationListFromJSON(jsonValue));
    }

    /**
     * Retrieve automations with optional filtering by room and device
     * Get automations
     */
    async getAutomations(requestParameters: GetAutomationsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AutomationList> {
        const response = await this.getAutomationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updateAutomation without sending the request
     */
    async updateAutomationRequestOpts(requestParameters: UpdateAutomationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['automationId'] == null) {
            throw new runtime.RequiredError(
                'automationId',
                'Required parameter "automationId" was null or undefined when calling updateAutomation().'
            );
        }

        if (requestParameters['automationInput'] == null) {
            throw new runtime.RequiredError(
                'automationInput',
                'Required parameter "automationInput" was null or undefined when calling updateAutomation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", []);
        }


        let urlPath = `/automations/{automationId}`;
        urlPath = urlPath.replace('{automationId}', encodeURIComponent(String(requestParameters['automationId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: AutomationInputToJSON(requestParameters['automationInput']),
        };
    }

    /**
     * Update an existing automation
     * Update an automation
     */
    async updateAutomationRaw(requestParameters: UpdateAutomationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Automation>> {
        const requestOptions = await this.updateAutomationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AutomationFromJSON(jsonValue));
    }

    /**
     * Update an existing automation
     * Update an automation
     */
    async updateAutomation(requestParameters: UpdateAutomationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Automation> {
        const response = await this.updateAutomationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
